import { is, pathOr } from 'ramda';

import { COUNTRIES_STANDARIZATION } from './mapChart.constants';

export const basicMapParser = (chartData) => {
  const { axis } = chartData;
  const series = pathOr([], ['series'])(chartData).filter((serie) => serie !== 'total');
  const serie = series[0] || pathOr([], ['series', 0])(chartData);

  chartData.serie = serie;
  chartData.series = series;
  chartData.country = chartData.axis;

  chartData.data.forEach((item) => {
    const value = item[serie];
    const country = item[axis];

    if (COUNTRIES_STANDARIZATION[country]) {
      item[axis] = COUNTRIES_STANDARIZATION[country];
    }

    if (is(Boolean, value)) {
      item[serie] = Number(value);
    }
  });
};
